import React from 'react';
import { FileIcon } from 'elements/Icon';

const XLS = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z"/>
    <g>
      <rect x="12.8" y="24" width="14" height="4"/>
      <rect x="33.1" y="24" width="14" height="4"/>
      <rect x="52.5" y="24" width="14" height="4"/>
      <rect x="72.8" y="24" width="14" height="4"/>
      <rect x="12.8" y="36" width="14" height="4"/>
      <rect x="33.1" y="36" width="14" height="4"/>
      <rect x="52.5" y="36" width="14" height="4"/>
      <rect x="72.8" y="36" width="14" height="4"/>
      <rect x="12.8" y="48" width="14" height="4"/>
      <rect x="33.1" y="48" width="14" height="4"/>
      <rect x="52.5" y="48" width="14" height="4"/>
      <rect x="72.8" y="48" width="14" height="4"/>
      <rect x="12.8" y="60" width="14" height="4"/>
      <rect x="33.1" y="60" width="14" height="4"/>
      <rect x="52.5" y="60" width="14" height="4"/>
      <rect x="72.8" y="60" width="14" height="4"/>
      <rect x="12.8" y="72" width="14" height="4"/>
      <rect x="33.1" y="72" width="14" height="4"/>
      <rect x="52.5" y="72" width="14" height="4"/>
      <rect x="72.8" y="72" width="14" height="4"/>
      <rect x="12.8" y="84" width="14" height="4"/>
      <rect x="33.1" y="84" width="14" height="4"/>
      <rect x="52.5" y="84" width="14" height="4"/>
      <rect x="72.8" y="84" width="14" height="4"/>
    </g>
    <rect x="12.8" y="102.6" width="74" height="24"/>
    <g>
      <path fill="#FFFFFF" className="text" d="M30.5,118.1h2.3v2.3h-2.4v-2.3H30.5z"/>
      <path fill="#FFFFFF" className="text" d="M37,120.5h-2.8l3.7-5.9l-3.5-5.6h2.9l2.1,3.8l2.1-3.8h2.8l-3.5,5.6l3.7,6h-2.9l-2.2-3.9L37,120.5z"/>
      <path fill="#FFFFFF" className="text" d="M45.8,108.9h2.4v9.4h5.7v2.1h-8.1V108.9z"/>
      <path fill="#FFFFFF" className="text" d="M57.3,116.9c0.1,0.5,0.2,0.9,0.4,1.2c0.4,0.5,1.1,0.7,2,0.7c0.6,0,1.1-0.1,1.4-0.2c0.7-0.2,1-0.7,1-1.3
        c0-0.4-0.2-0.7-0.5-0.9c-0.3-0.2-0.9-0.4-1.6-0.5l-1.2-0.3c-1.2-0.3-2.1-0.6-2.5-0.9c-0.8-0.5-1.2-1.4-1.2-2.5c0-1,0.4-1.9,1.1-2.6
        c0.8-0.7,1.9-1,3.3-1c1.2,0,2.3,0.3,3.1,1s1.3,1.6,1.4,2.8h-2.3c0-0.7-0.4-1.2-0.9-1.5c-0.4-0.2-0.9-0.3-1.4-0.3
        c-0.6,0-1.1,0.1-1.5,0.4s-0.6,0.6-0.6,1s0.2,0.7,0.6,0.9c0.2,0.1,0.8,0.3,1.5,0.5l2,0.5c0.9,0.2,1.5,0.5,2,0.8c0.7,0.5,1,1.3,1,2.4
        s-0.4,1.9-1.2,2.6s-2,1-3.4,1c-1.5,0-2.7-0.3-3.6-1s-1.3-1.6-1.3-2.8C54.9,116.9,57.3,116.9,57.3,116.9z"/>
    </g>
  </FileIcon>
);

export default XLS;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/XLS.jsx